export default "__VITE_ASSET__YN23seyZ__"